const Footer = ()=>{
    return (
        <div style={{textAlign:'center',marginTop:'20px',backgroundColor:'rgba(161, 214, 255, 0.2)',padding:'10px'}}>
            <p>It's a simple project i have made to display the wheather data using Ambee data API service, it's free to use with certain limitations</p>
            <p>Happy coding</p>
        </div>
    )
}

export default Footer;